module.exports = __webpack_public_path__ + "img/icon_agency_selected.530601db.svg";